"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetIsPreOrder = exports.useGetPurchaseStatus = exports.TWO_HOURS = void 0;
var TileDataContext_1 = require("../components/TileDataContext");
exports.TWO_HOURS = 7200;
function useGetPurchaseStatus() {
    var tileData = (0, TileDataContext_1.useTileDataContext)().tileData;
    if (tileData.vehicleUnlockDateTime == null) {
        return {
            isLocked: false,
            isOnHold: false
        };
    }
    var timeLeft = Date.parse(tileData.vehicleUnlockDateTime) - +new Date();
    return {
        isLocked: Math.floor(timeLeft / 1000) >= exports.TWO_HOURS,
        isOnHold: Math.floor(timeLeft / 1000) < exports.TWO_HOURS
    };
}
exports.useGetPurchaseStatus = useGetPurchaseStatus;
function useGetIsPreOrder() {
    var tileData = (0, TileDataContext_1.useTileDataContext)().tileData;
    var _a = useGetPurchaseStatus(), isLocked = _a.isLocked, isOnHold = _a.isOnHold;
    return isLocked || isOnHold
        ? false
        : tileData.vehicleInventoryType === TileDataContext_1.InventoryTypeId.WIP;
}
exports.useGetIsPreOrder = useGetIsPreOrder;
//# sourceMappingURL=useStatusHooks.js.map